var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homepage mx-auto"},[_c('browse',{attrs:{"listing_type":'company-listings'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }